/**
 * Copyright ©2022 Drivepoint
 */

import ServiceRegistry from "@services/ServiceRegistry";
import State from "../state/State";

export default class CompanyService extends EventTarget {

  constructor() {
    super();
    State.register("user", this.onUserStateChange.bind(this));
  }

  private _rehydrateCompany() {
    const pathSegment = location.pathname.split("/")?.[1];
    // Only set from the URL when it actually matches a real company id. Otherwise (e.g. on
    // /quickstart or /sign_in) we'd write company=undefined here, which triggers the SSE
    // service's "company" listener to reconnect, causing an infinite state/reconnect loop.
    if (pathSegment && !pathSegment.startsWith(":") && this.getCompanyById(pathSegment)) {
      this.setCompanyById(pathSegment);
    }
    if (!this.company && this.companies.length > 0) {
      this.setCompanyById(this.companies[0].id);
    }
  }

  async init(): Promise<void> {}

  onUserStateChange(): void {
    if (!State.get("user")) {
      this.reset();
    } else {
      this._rehydrateCompany();
    }
  }

  getCompanyById(id?: string): any {
    return this.companies.find((company: any) => company.id === id);
  }

  setCompanyById(id?: string): void {
    if (id) {
      this.company = this.getCompanyById(id);
    }
  };

  reset(): void {
    this.company = undefined;
  }

  get company(): any {
    return State.get("company");
  }

  set company(value: any | undefined) {
    State.set("company", value);
  }

  get companies(): any[] {
    return State.get("user")?.companies || [];
  }

  hasAdminAccess(): boolean {
    const user = State.get("user");
    const role = user?.excelUser?.role;
    return role === "admin" || role === "superAdmin";
  }

  switchCompany(id: string, page?: any): void {
    Object.keys(sessionStorage).forEach(key => {
      if (key.includes("drivepoint_plan")) { sessionStorage.removeItem(key); }
    });
    const defaultPage = page?.current || ServiceRegistry.routeService.defaultPage;
    let path = defaultPage.path;
    const matches = Array.from(window.location.pathname.match(defaultPage.pattern) || []);
    const tokens = ServiceRegistry.routeService.getPathTokens(path);
    for (const [index, token] of tokens.entries()) {
      switch (token) {
        case ":company":
          path = path.replace(token, id);
          break;
        case ":bundle_id":
          path = path.replace(token, matches[index + 1]);
          break;
        case ":id":
          path = path.replace(token, matches[index + 1]);
          break;
      }
    }
    ServiceRegistry.companyService.setCompanyById(id);
    window.location.assign(path);
  }

}
